import { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { AppContext } from "../../../appContext/AppContext";
import { TableCustom } from "../../table/table-custom/TableCustom";
import { CODE } from "../../../utils/Constant";
import { columnsPreshipment } from "../const/Columns";
import { getListPreshipment } from "../QuanLyKhoServices";
import ModelHeader from "../../ModelHeader";

interface Props {
    show: boolean;
    onHide: () => void;
    itemData: any;
}

const DialogPreshipment = (props: Props) => {
    const { show, onHide, itemData } = props;
    const { setIsLoading } = useContext(AppContext);
    const [dsPreshipment, setDsPreshipment] = useState<any[]>([]);

    const fetchData = async () => {
        const itemId = itemData?.itemId || itemData?.id;
        if (!itemId || !itemData?.warehouseId) return;

        try {
            setIsLoading(true);
            const { data } = await getListPreshipment({
                itemId: itemId,
                warehouseId: itemData.warehouseId,
                serialNumber: itemData.serialNumber || undefined,
                consignment: itemData.consignment || undefined,
                sellingPrice: itemData.sellingPrice || undefined,
                expiryDate: itemData.expiryDate || undefined,
                salePrice: itemData.salePrice || undefined,
                bhytPrice: itemData.bhytPrice || undefined,
                hospitalPrice: itemData.hospitalPrice || undefined,
                servicePrice: itemData.servicePrice || undefined,
            });
            if (CODE.SUCCESS === data.code) {
                setDsPreshipment(data?.data || []);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (show) {
            fetchData();
        }
    }, [show]);

    return (
        <Modal
            centered
            show={show}
            onHide={onHide}
            size="lg"
            className="spaces"
        >
            <ModelHeader onHide={onHide} title="Danh sách phiếu chờ xuất" />
            <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10 py-10">
                    <div className="spaces bg-white mb-0">
                        <TableCustom<any>
                            className="spaces h-300px"
                            data={dsPreshipment}
                            columns={columnsPreshipment}
                            verticalScroll={true}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DialogPreshipment;
